import { action, observable, runInAction } from 'mobx'
import { StoreExt } from '@utils/reactExt'
import { IBettorFind, Schema$Bettor } from '@protocol/bettor'
import _ from 'lodash'
import { message } from 'antd'
import { GIFT_BTN_TYPE } from '@constants/index'
import { BETTOR_FIND_TYPE } from '@v2/constants/common'

export class BettorStore extends StoreExt {

  @observable
  giftBtnType: GIFT_BTN_TYPE

  @observable
  bettors: Schema$Bettor[]

  @observable
  bettorFindHasMore = false

  @observable
  bettorFindOffset = 0

  @observable
  bettorFindLimit = 50

  @observable
  isLoadingBettors = false

  @action
  resetBettorFindState = (): void => {
    this.bettorFindOffset = 0
    this.bettorFindLimit = 50
    this.bettorFindHasMore = false
    this.bettors = []
  }

  @action
  fetchBettors = async (bettorFindType: BETTOR_FIND_TYPE, searchNick?: string, reset = false): Promise<void> => {
    try {
      if (_.isNil(bettorFindType)) {
        return
      }

      if (this.isLoadingBettors) {
        return
      }

      if (reset) {
        this.resetBettorFindState()
      }

      const params: IBettorFind.Params = {
        bettorFindType,
        nick: searchNick,
        offset: this.bettorFindOffset,
        limit: this.bettorFindLimit,
      }

      this.setLoading(true)

      const { items, hasMore } = await this.api.bettor.fetchBettors(params)
      runInAction(() => {
        this.bettors = this.bettors.concat(items)
        this.bettorFindHasMore = hasMore
        if (hasMore) {
          this.bettorFindOffset += this.bettorFindLimit
        }
        this.setLoading(false)
      })
    } catch (err) {
      message.error(err.message)
      this.setLoading(false)
    }
  }

  @action
  setLoading(isLoading: boolean): void {
    this.isLoadingBettors = isLoading
  }

  @action
  setGiftBtnType = (type: GIFT_BTN_TYPE): void => {
    this.giftBtnType = type
  }
}

export default new BettorStore()
